import React from "react";
import { Spin } from "antd";
import "./LoadingSpinner.scss";

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <Spin size="large" />
      <p className="loading-text">Processing Pls Wait.</p>
    </div>
  );
}

export default LoadingSpinner;
